module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Expand-arrows-8b95a9cfff43bb5dccede004a26d484b.svg";